import Link from 'next/link';

import styles from './PageTitle.module.scss';

export default function PageTitle({ title, heading }) {
  return (
    <section className={styles.section}>
      <div className={styles.content}>
        <h1 className={styles.title}>{title}</h1>
        <div className={styles.breadcrumbs}>
          <Link href="/">
            <span className={styles.breadcrumbPrevious}>Αρχική</span>
          </Link>
          <span className={styles.breadcrumbSeparator}>/</span>
          <span>{heading || title}</span>
        </div>
      </div>
    </section>
  );
}
